import { InvoiceCopyType } from '../../../containers/agreement/Invoice/components/UploadInvoice';
import { Dict } from '../../models';
import { ApiResponse, CancellationData, ListSort, PaginatedApiResponse } from '../models';
import { LeadConfiguration } from '../models/configuration';
import * as http from './http';
import ApiService from './service';

export class InvoiceService extends ApiService {
  async createInvoice(data: { leadId: string; configId: string }) {
    const url = `${this.apiDomain}/api/configuration/invoice`;
    const response = await http.post<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async reCreateInvoice(data: {
    leadId: string;
    configId: string;
    menuCodes?: string[];
  }) {
    const url = `${this.apiDomain}/api/configuration/invoice/re-invoice`;
    const response = await http.post<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async cancelInvoiceRequest(id: string, data: CancellationData) {
    const url = `${this.apiDomain}/api/configuration/${id}/invoice/cancel/request`;

    const response = await http.post<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }
  public async acceptCancelRequest(
    configId: string,
    data: {
      comments: string;
    }
  ): Promise<void> {
    const url = `${this.apiDomain}/api/configuration/${configId}/invoice/cancel/approve`;
    await http.put(url, data, this.store);
  }

  public async rejectCancelRequest(
    configId: string,
    data: {
      comments: string;
    }
  ): Promise<void> {
    const url = `${this.apiDomain}/api/configuration/${configId}/invoice/cancel/reject`;
    await http.put(url, data, this.store);
  }

  async validateInvoice(data: {
    leadId: string;
    configId: string;
    menuCodes?: string[];
    invoiceCreatedDate: Date;
    registrationDate: Date;
    actualDeliveryDate: Date;
  }) {
    const url = `${this.apiDomain}/api/configuration/${data.configId}/invoice/validate`;
    const response = await http.post<ApiResponse<any>>(url, data, this.store);
    return response.data;
  }

  async syncInvoice(data: {
    leadId: string;
    configId: string;
    menuCodes?: string[];
  }) {
    const url = `${this.apiDomain}/api/configuration/${data.configId}/invoice/sync`;
    const response = await http.post<ApiResponse<any>>(url, data, this.store);
    return response.data;
  }

  public async getInvoiceList(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<any[]>> {
    const url = `${this.apiDomain}/api/invoice/list`;
    const response = await http.post<PaginatedApiResponse<any[]>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }
  public async getTransaction360List(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<any[]>> {
    const url = `${this.apiDomain}/api/invoice/transaction-360`;
    const response = await http.post<PaginatedApiResponse<any[]>>(
      url,
      data,
      this.store
    );
    return response?.data;
  }

  public async revertTransaction(
    data: {
      reason: string,
      paymentHistoryIds:string[],
      refundMethod:string
      refundAmount:number
      // refundTo:string
      comment:string,
      invoiceCopyType :InvoiceCopyType,
    },
  ): Promise<PaginatedApiResponse<any[]>> {
    const url = `${this.apiDomain}/api/proposal-document/revert-transactions`;
    const response = await http.post<PaginatedApiResponse<any[]>>(
      url,
      data,
      this.store
    );
    return response?.data;
  }
}

